/**
 * archive-loader.ts
 * Handling "Load more" functionality for Blog and Reference archives (standard WP pagination).
 * Fetches the next page content via AJAX and appends it to the current list.
 */

const initArchiveLoader = () => {
    const container = document.querySelector('.Archive');
    if (!container) return;

    const grid = container.querySelector('.Archive-grid');
    if (!grid) return;

    // Function to handle "Load more" click
    const handleLoadMore = async (e: Event) => {
        const button = (e.target as HTMLElement).closest('a');
        if (!button) return;

        // Verify it's inside the Pager (to avoid other links)
        const pager = button.closest('.Pager');
        if (!pager) return;

        // Verify it's the "next" link (or "Load more" button structure)
        // The current structure has .Pager-loadMore containing the button.
        if (!button.closest('.Pager-loadMore')) return;

        e.preventDefault();
        const url = button.href;

        // Add loading state
        button.classList.add('is-loading');
        const spinner = button.querySelector('.ButtonLoader') as HTMLElement;
        if (spinner) spinner.style.display = 'block';

        // Hide the count during loading if needed, or keep it.
        // User wants "Load more" behavior.

        try {
            const response = await fetch(url);
            if (!response.ok) throw new Error('Network response was not ok');

            const html = await response.text();
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');

            // 1. Append new posts
            const newGrid = doc.querySelector('.Archive-grid');
            if (newGrid) {
                const newPosts = Array.from(newGrid.children);
                newPosts.forEach((post) => {
                    grid.appendChild(post);
                });
            }

            // 2. Replace Pager
            const newPager = doc.querySelector('.Pager');
            if (newPager) {
                pager.replaceWith(newPager);
                // Re-attach event listener? 
                // delegated listener on container accounts for replaced elements if attached to container.
                // But here we attached to nothing yet. We need delegation.
            } else {
                // No more pages? Remove pager.
                pager.remove();
            }

            // 3. Update URL
            // Use the fetched URL or constructing ?strana=X
            window.history.pushState(null, '', url);

        } catch (error) {
            console.error('Error loading more posts:', error);
            window.location.href = url; // Fallback to normal navigation
        } finally {
            button.classList.remove('is-loading');
            if (spinner) spinner.style.display = 'none';

            // Re-initialize any JS components for new posts if needed (e.g. lazy loading, lightbox)
            // For now, standard content.
        }
    };

    // Event Delegation
    container.addEventListener('click', handleLoadMore);
};

export default initArchiveLoader;
